<template>
    <div class="preloader">
        <Vue3Lottie class="animate" :animationData="loaderJSON" width="140px" height="140px"></Vue3Lottie>
    </div>
</template>

<script lang="ts" setup>
import loaderJSON from '@/static/img/preloader-web-blue.json'
import { Vue3Lottie } from 'vue3-lottie'
</script>

<script lang="ts">
export default {
    name: 'vita-loader'
}
</script>

<style lang="scss">
    .preloader {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        top: 0;
        display: flex;
        background: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(2.5px);

        .animate {
            display: block;
            margin: auto;
        }
    }
</style>